import React from 'react';
import { CgChevronDown, CgChevronLeft } from 'react-icons/cg';

const menuData = [
    {
        title: 'Home',
        path: '/',
        iconClosed: <CgChevronLeft />,
        iconOpened: <CgChevronDown />,
    },

    {
        title: 'About',
        path: '/about',
    },
    {
        title: 'Services',
        path: '/services',
    },
    {
        title: 'Contact',
        path: '/contact',
    },
    {
        title: 'Shop',
        path: '/shop',
    },
];

export default menuData;
